export enum EConsultationRequestActions {
  SetModalOpen = 'consultationRequest/setModalOpen',
}
